import { useParams, Navigate } from "react-router-dom";
import { SiteHeader, SiteFooter } from "./SiteLayout";
import { useSiteContent, usePageMeta } from "./siteContent";
import SiteSections from "./SiteSections";

const PAGE_KEYS = {
  "medical-event-cover": "service-medical",
  "sports-event-medical-cover": "service-sports",
};

export default function SiteServiceDetail() {
  const { slug } = useParams();
  const site = useSiteContent();
  const svcMeta = (site.services_catalog || []).find((s) => s.slug === slug);
  const key = PAGE_KEYS[slug];
  usePageMeta(
    svcMeta ? `${svcMeta.name} | Wales Event Medical Services` : "Our Services | Wales Event Medical Services",
    svcMeta ? svcMeta.tagline : "Professional event medical cover across the UK.", "", key);
  let sections = key ? site.page_sections[key] : null;
  if (!sections) {
    const svc = (site.services_catalog || []).find((s) => s.slug === slug);
    if (!svc) return <Navigate to="/services" replace />;
    sections = [
      { id: "hero", type: "page_hero", title: svc.name, subtitle: svc.tagline, image: svc.image },
      { id: "detail", type: "checklist", card: true, eyebrow: "Service", heading: svc.name,
        paragraphs: [svc.description || svc.tagline], list_title: "What's included", items: svc.points || [],
        buttons: [
          { label: "Get a Quote", to: "/intake", style: "primary", tid: "service-quote" },
          { label: "Staff Calculator", to: "/staff-calculator", style: "outline", tid: "service-calculator" },
        ] },
    ];
  }
  return (
    <div className="site-font bg-[#0B0F14]" data-testid={`site-service-${slug}`}>
      <SiteHeader />
      <SiteSections sections={sections} services={site.services_catalog} contact={site.contact_info} />
      <SiteFooter />
    </div>
  );
}
